import { render, staticRenderFns } from "./StarToggle.vue?vue&type=template&id=77655d5d&"
import script from "./StarToggle.vue?vue&type=script&lang=ts&"
export * from "./StarToggle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports